import _slicedToArray from "/builds/habi_co/habi-sales/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React, { Fragment, useEffect, useState } from "react";
import { Title, Intro, Upz, Price, Status, InfoTooltip } from "./style";
import { Bed, Bath, Measure, Car, Elevator } from "./svgObjects";
import NumberFormat from "react-number-format";
import { coral, white } from "../StylesConstants";
import InfoRoundedIcon from "@material-ui/icons/InfoRounded";
var TitleCard = function TitleCard(props) {
  var _useState = useState(""),
    _useState2 = _slicedToArray(_useState, 2),
    title = _useState2[0],
    setTitle = _useState2[1];
  var _useState3 = useState(""),
    _useState4 = _slicedToArray(_useState3, 2),
    rooms = _useState4[0],
    setRooms = _useState4[1];
  var _useState5 = useState(""),
    _useState6 = _slicedToArray(_useState5, 2),
    bathrooms = _useState6[0],
    setBathrooms = _useState6[1];
  var _useState7 = useState(""),
    _useState8 = _slicedToArray(_useState7, 2),
    parking = _useState8[0],
    setParking = _useState8[1];
  var _useState9 = useState(""),
    _useState10 = _slicedToArray(_useState9, 2),
    area = _useState10[0],
    setArea = _useState10[1];
  var _useState11 = useState(""),
    _useState12 = _slicedToArray(_useState11, 2),
    elevators = _useState12[0],
    setElevators = _useState12[1];
  var _useState13 = useState(""),
    _useState14 = _slicedToArray(_useState13, 2),
    upz = _useState14[0],
    setUpz = _useState14[1];
  var _useState15 = useState(""),
    _useState16 = _slicedToArray(_useState15, 2),
    price = _useState16[0],
    setPrice = _useState16[1];
  var _useState17 = useState(""),
    _useState18 = _slicedToArray(_useState17, 2),
    offerPrice = _useState18[0],
    setOfferPrice = _useState18[1];
  var _useState19 = useState(null),
    _useState20 = _slicedToArray(_useState19, 2),
    ciudad = _useState20[0],
    setCiudad = _useState20[1];
  useEffect(function () {
    setTitle(props.title);
    setUpz(props.upz);
    setRooms(props.rooms);
    setBathrooms(props.bathrooms);
    setParking(props.parking);
    setArea(props.area);
    setElevators(props.elevators);
    setPrice(props.price);
    setOfferPrice(props.offerPrice);
    setCiudad(props.ciudad);
  }, [props.title, props.upz, props.rooms, props.bathrooms, props.parking, props.area, props.elevators, props.price, props.offerPrice, props.ciudad]);
  var tooltipMessage = "Este es un inmueble en trámite, apártalo con nosotros y obtén grandes beneficios.";
  return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(Title, null, /*#__PURE__*/React.createElement("h1", {
    className: "main-title"
  }, title)), props.availableFor === "en_tramite" && props.statusInmueble !== 3 && /*#__PURE__*/React.createElement(Status, {
    className: "status-aparment",
    bgColor: coral,
    textColor: white
  }, "EN TR\xC1MITE", /*#__PURE__*/React.createElement(InfoTooltip, {
    disableFocusListener: true,
    title: tooltipMessage,
    arrow: true,
    placement: "right"
  }, /*#__PURE__*/React.createElement(InfoRoundedIcon, {
    className: "status-icon"
  }))), price && /*#__PURE__*/React.createElement(Price, null, /*#__PURE__*/React.createElement("p", {
    className: "title-price"
  }, "PRECIO DE VENTA"), /*#__PURE__*/React.createElement("div", {
    className: "values-price"
  }, offerPrice && /*#__PURE__*/React.createElement("p", {
    className: "price-offer"
  }, /*#__PURE__*/React.createElement(NumberFormat, {
    value: price,
    displayType: "text",
    thousandSeparator: true,
    className: "text-value",
    prefix: "$",
    decimalScale: false
  }), " ", "\xA0"), /*#__PURE__*/React.createElement("p", {
    className: offerPrice ? "old-price" : "price"
  }, /*#__PURE__*/React.createElement(NumberFormat, {
    value: offerPrice ? offerPrice : price,
    displayType: "text",
    thousandSeparator: true,
    className: "text-value",
    prefix: "$",
    suffix: offerPrice ? "" : " ".concat(!!props.TranslateCurrencies ? props.TranslateCurrencies : "COP"),
    decimalScale: false
  })))), /*#__PURE__*/React.createElement(Upz, null, /*#__PURE__*/React.createElement("p", {
    className: "ubication"
  }, ciudad || "Bogotá", ", ", upz)), /*#__PURE__*/React.createElement(Intro, null, rooms && /*#__PURE__*/React.createElement("div", {
    className: "item-prop"
  }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Bed, {
    className: "icon"
  })), /*#__PURE__*/React.createElement("span", {
    className: "titulo"
  }, rooms, " ", rooms != 1 ? !!props.TranslateRoomPlural ? props.TranslateRoomPlural : "Habitaciones" : !!props.TranslateRoomSingular ? props.TranslateRoomSingular : "Habitación")), bathrooms && /*#__PURE__*/React.createElement("div", {
    className: "item-prop"
  }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Bath, {
    className: "icon"
  })), /*#__PURE__*/React.createElement("span", {
    className: "titulo"
  }, bathrooms, " ", bathrooms != 1 ? "Baños" : "Baño")), parking != null && /*#__PURE__*/React.createElement("div", {
    className: "item-prop"
  }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Car, {
    className: "icon"
  })), /*#__PURE__*/React.createElement("span", {
    className: "titulo"
  }, parking, " ", parking != 1 ? !!props.TranslateParkingPlural ? props.TranslateParkingPlural : "Parqueaderos" : !!props.TranslateParkingSingular ? props.TranslateParkingSingular : "Parqueadero")), area && /*#__PURE__*/React.createElement("div", {
    className: "item-prop"
  }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Measure, {
    className: "icon"
  })), /*#__PURE__*/React.createElement("span", {
    className: "titulo"
  }, area, "m", /*#__PURE__*/React.createElement("sup", null, "2"))), elevators != null && /*#__PURE__*/React.createElement("div", {
    className: "item-prop"
  }, /*#__PURE__*/React.createElement("span", {
    className: "icon-ascensor"
  }, /*#__PURE__*/React.createElement(Elevator, null)), /*#__PURE__*/React.createElement("span", {
    className: "titulo"
  }, elevators, " ", elevators != 1 ? !!props.TranslateElevatorPlural ? props.TranslateElevatorPlural : "Ascensores" : !!props.TranslateElevatorSingular ? props.TranslateElevatorSingular : "Ascensor"))));
};
export default TitleCard;